import React from 'react';

import get from 'lodash/get';
import PropTypes from 'prop-types';
import { useFieldArray } from 'react-hook-form';

import { getFilteredGroupsIds, getGroupIem } from '../helpers';

import GroupItem from './GroupItem';

const FieldArray = ({
    category,
    control, // Recibimos control de RHF
    disabled,
    formValues,
    name,
    roleLevel,
}) => {
    const { fields } = useFieldArray({
        control,
        name, // Nombre del campo array (en este caso, "groups")
    });

    const groups = get(formValues, 'groups', []);
    const groupsIds = getFilteredGroupsIds(category, groups);

    return fields.map((field, index) => {
        const group = getGroupIem(formValues, index);
        const newIndex = groupsIds.indexOf(group.id);
        if (group.category !== category) return null;
        return (
            <GroupItem
                control={control} // Pasamos control
                disabled={disabled}
                index={newIndex}
                item={group}
                key={`group-${group.id}`}
                name={`${name}.${index}.permission_level`} // Nombre completo
                roleLevel={roleLevel}
            />
        );
    });
};

FieldArray.propTypes = {
    category: PropTypes.string,
    control: PropTypes.object.isRequired, // Control es requerido para useFieldArray
    disabled: PropTypes.bool,
    formValues: PropTypes.object,
    name: PropTypes.string.isRequired, // Nombre del campo array
    roleLevel: PropTypes.object,
};

export default FieldArray;
